import { SearchInput } from "@finanedi.es/storybook"
import { TicketParamsProps } from "api/Ticket.service"
import { Dispatch, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const FilterMenu = ({
  serviceQuery,
  sortingCriteria,
  skipCount,
  maxResultCount,
  resetPagination,
}: {
  serviceQuery: Dispatch<Partial<TicketParamsProps>>
  sortingCriteria?: TicketParamsProps["SortingCriteria"]
  skipCount?: TicketParamsProps["SkipCount"]
  maxResultCount?: TicketParamsProps["MaxResultCount"]
  resetPagination?: () => void
}) => {
  const { t } = useTranslation()

  const [keyword, setKeyword] = useState<string | undefined>()

  const queryFixer = (queryParams: Partial<TicketParamsProps>) => {
    const reembolsoParams = {
      Keyword: queryParams.Keyword,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "FechaEmision DESC",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(reembolsoParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }

  const query = {
    Keyword: keyword,
    MaxResultCount: maxResultCount,
    SkipCount: skipCount,
    SortingCriteria: sortingCriteria,
  }

  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }

  useEffect(() => {
    resetPagination?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword])

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    keyword,
    sortingCriteria?.sort,
    sortingCriteria?.property,
    skipCount,
    maxResultCount,
  ])

  return (
    <>
      <div className='!tw-bg-white !tw-px-6 tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl mb-1'>
        <p className='tw-whitespace-nowrap tw-text-2xl tw-text-text tw-my-auto'>
          {t("reembolsoTickets.title")}
        </p>
        <div className='tw-flex tw-w-full tw-justify-center xl:tw-justify-end'>
          <div className='!tw-w-fit tw-flex tw-items-center !tw-flex-row tw-justify-end tw-flex-wrap'>
            <div className='tw-grid tw-gap-3 2xl:tw-flex 2xl:tw-flex-row tw-items-center tw-w-fit'>
              <SearchInput
                placeholder={`${t("validaciones.placeholderSearch")}`}
                onChange={(ev: string) => {
                  resetPagination?.()
                  setKeyword(ev)
                }}
                inputValue={keyword}
                className='tw-mb-1 sm:tw-mb-0 tw-h-10 tw-w-full 2xl:tw-w-72'
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
